var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.options, function (item, i) {
      return _c("span", { key: i }, [
        i > 0
          ? _c(
              "span",
              { staticClass: "list-summary-info-text info-text plusItem" },
              [_vm._v("+")]
            )
          : _vm._e(),
        _vm._v(" "),
        item.qty != 1
          ? _c("span", { staticClass: "list-summary-info-text info-text" }, [
              _vm._v(_vm._s(item.qty) + " x"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "list-summary-info-text info-text" }, [
          _vm._v(_vm._s(item.product.dn)),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }